<div class="footer bg-img" data-aos="fade-up" data-aos-duration="1000">
  <div class="container">
    <footer class="d-flex flex-wrap justify-content-evenly align-items-center py-4 py-lg-5">
      <div
        class="col-12 col-sm-12 col-lg-4 order-2 order-sm-2 order-lg-0 flex-fill align-items-center justify-content-center justify-content-md-start text-center text-lg-start pt-sm-4 pt-lg-0">
        <span class="">© Cheer Factory Inc., {{year}}</span>
      </div>

      <ul
        class="nav col-12 col-sm-9 col-lg-7 order-0 order-sm-0 order-lg-1 flex-fill justify-content-center justify-content-sm-start justify-content-lg-end list-unstyled">
        <li class="nav-item order-2 order-sm-0">
          <a class="nav-link pe-1 ps-sm-0" href="assets/TERMS-AND-CONDITIONS-January-20-2022.pdf" target="_blank">Terms and Conditions</a>
        </li>
        <li class="nav-item order-1  order-sm-1">
          <a class="nav-link px-2 px-sm-4" href="assets/PRIVACY-POLICY-March-3-2020.pdf" target="_blank">Privacy Policy</a>
        </li>
        <li class="nav-item order-0  order-sm-2">
          <a class="nav-link ps-1 pe-sm-0" href="javascript:void()" (click)="click()">Contact Us</a>
        </li>
      </ul>

      <ul
        class="nav col-12 col-sm-3 col-lg-1 order-1 order-sm-1 order-lg-2 list-unstyled flex-fill justify-content-center justify-content-sm-end justify-content-md-end py-3 py-sm-0">
        <li class="ms-3"><a class="" href="https://www.facebook.com/thecheerforge/" target="_blank"><i class="text-gold fa-brands fa-facebook"></i></a></li>
        <li class="ms-3"><a class="" href="https://www.instagram.com/thecheerforge/" target="_blank"><i class="text-gold fa-brands fa-instagram"></i></a></li>
      </ul>
    </footer>
  </div>
</div>